import React, { useState, useEffect } from 'react';
import { Card, Col, Row } from 'antd';
import { section, sectionField } from '../../types/types';
import { GetRequest } from '../../utils/api';
import { copyToClipboard } from '../../utils/utils';
import { useTranslation } from 'react-i18next';
import { CopyOutlined } from '@ant-design/icons';
import CustomLoader from '../loader';
interface Props {
  urlparams: Map<string, string>;
  section: section;
}
const RecordHeader: React.FC<Props> = ({
  urlparams,
  section,
}) => {

  const [sectionFieldValues, setSectionFieldValues] = useState<any[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [errorMessage, setErrorMessage] = useState<string>();

  const { t} = useTranslation();

  let actualApi = section.api;
  urlparams.forEach((value, key) => {
    actualApi = actualApi?.replace("{" + key + "}", value);
  });

  
  const fetchPanelValues = () => {

      GetRequest(actualApi).then((data:any) => {
        setLoading(false);
        if (data.hasOwnProperty('records')) {
          setSectionFieldValues(data.records);
        } else {
          let singleRecord = [];
          singleRecord.push(data);
          setSectionFieldValues(singleRecord);
        }
      }).catch((err:Error) => {
        setLoading(false);
        setErrorMessage(err?.message);
      });
  }

  useEffect(() => {
    fetchPanelValues();
  }, []);


  if (loading) {
    return (
      <div className="panel-loading">
        <CustomLoader/>
      </div>
    );
  } else if (errorMessage) {
    <div className='text-center'> Something went wrong: {errorMessage} </div>
  } else if (Object.keys(sectionFieldValues).length === 1) {
    let sectionValues = sectionFieldValues[0];
   
    return (
      <Card className="my-2">

        <Row>
          {section.viewForm?.map((sectionField: sectionField, index: number) =>
            <Col key={index} span={6} lg={6} xs={24}>
              <div className={"ant-form-item ant-form-item-has-success"}>
                <div>
                  <label className={"display-name font-medium text-primary"}>{t(sectionField.displayName)}</label>
                </div>
                <div>
                  <label className='font-semibold'>
                    {t(sectionValues[sectionField.field])}
                    {sectionField.mobileCopyIcon &&  <span className={"display-only-mobile mx-2"} onClick={() => copyToClipboard(sectionValues[sectionField.field])}>
                    <CopyOutlined rev={undefined}></CopyOutlined>
                    </span>}
                  </label>
                </div>
              </div>
            </Col>
          )}
        </Row>

      </Card>
    );
  } else if (Object.keys(sectionFieldValues).length > 1) {
    return (<div className='text-center'>Please contact your administrator, displaying more than one record is not allowed in header</div>)
  }

  return (<></>)

};

export default RecordHeader;
